import React from 'react';

interface Insight {
  type: string;
  title: string;
  message: string;
  actionable: string;
  priority: string;
}

interface InsightsPanelProps {
  insights: Insight[];
}

const InsightsPanel: React.FC<InsightsPanelProps> = ({ insights }) => {
  if (insights.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
          💡 Insights
        </h3>
        <div className="text-center py-8">
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
          <p className="text-gray-500">Complete more tasks to unlock personalized insights!</p>
        </div>
      </div>
    );
  }

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high': return '#ef4444';
      case 'positive': return '#10b981';
      case 'improvement': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getPriorityBg = (priority: string) => {
    switch (priority) {
      case 'high': return '#fef2f2';
      case 'positive': return '#f0fdf4';
      case 'improvement': return '#fffbeb';
      default: return '#f9fafb';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>
        💡 Personal Insights
      </h3>
      
      <div className="space-y-4">
        {insights.map((insight, index) => (
          <div 
            key={index}
            style={{
              backgroundColor: getPriorityBg(insight.priority),
              border: `1px solid ${getPriorityColor(insight.priority)}20`,
              borderRadius: '8px',
              padding: '1rem'
            }}
          >
            <div style={{ 
              fontSize: '1rem', 
              fontWeight: 600, 
              color: getPriorityColor(insight.priority),
              marginBottom: '0.5rem'
            }}>
              {insight.title}
            </div>
            <div style={{ 
              fontSize: '0.875rem', 
              color: '#374151',
              marginBottom: '0.5rem'
            }}>
              {insight.message}
            </div>
            <div style={{ 
              fontSize: '0.75rem', 
              color: '#6b7280',
              fontStyle: 'italic'
            }}>
              💡 {insight.actionable}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsPanel;
